import { listUsersInTenant } from "@/apis";
import { processResponse } from "./_helper";
import { createUsersInTenant, deleteUsersInTenant, getUserInTenant, syncCreationToVIA, syncDeletionToVIA, syncUpdateToVIA, updateUsersInTenant } from "@/apis/users";

export const RESOURCE_TYPE_USERS = 'users';

const getTenantName = (meta) => {
  return meta.tenantName || '__root__';
};

export const UsersDataProvider = {
  getList: async ({ pagination, filters, sorters, meta }) => {
    const resp = await listUsersInTenant(getTenantName(meta));
    console.log("UsersDataProvider.getList", resp);
    const users = processResponse(resp);
    // enrich location if not exists
    users.forEach(element => {
      if (element.storage == 'cognito') {
        element.storeInCognito = true
      }
      if (element.storage == 'native') {
        element.storeInCognito = false
      }
      if (element.properties) {
        for (const key in element.properties) {
          if (!Object.hasOwnProperty.call(element, key)) {
            element[key] = element.properties[key];
          }
        }
      }
    })

    return {
      data: users,
      total: users.length,
    };
  },
  getOne: async ({ id, meta }) => {
    const resp = await getUserInTenant(getTenantName(meta), id);
    const raw = processResponse(resp);
    if (raw.storage === 'cognito') {
      raw.storeInCognito = true;
    }
    if (raw.storage === 'native') {
      raw.storeInCognito = false;
    }
    if (raw.properties) {
      for (const key in raw.properties) {
        if (!Object.hasOwnProperty.call(raw, key)) {
          raw[key] = raw.properties[key];
        }
      }
    }
    return raw;
  },
  create: async ({ variables, meta }) => {
    const tenantName = getTenantName(meta);
    if (tenantName === '__root__') {
      variables.roles = 'admin:nest';
    } else if (variables.isAdmin) {
      variables.roles = 'admin';
    }
    if (variables.storeInCognito === true) {
      variables.storage = 'cognito';
    }
    if (variables.storeInCognito === false) {
      variables.storage = 'native';
    }
    // we don't need other UI properties, only keep UM required properties
    // isAdmin is represented as roles=admin
    delete variables.isAdmin;
    const resp = await createUsersInTenant(tenantName, variables);
    const user = processResponse(resp);
    const syncResp = await syncCreationToVIA(tenantName, user?.name || variables.name);
    //TODO: currently, the API does not return the created user, so we fake it here
    let result = user || variables;
    if (syncResp && syncResp.status === 'OK') {
      result.synced = true;
    }
    return result;
  },
  update: async ({ id, variables: { action, data }, meta }) => {
    if (data.isAdmin === true) {
      data.roles = 'admin';
    }
    if (data.isAdmin === false) {
      data.roles = '-admin';
    }
    if (data.storeInCognito === true) {
      data.storage = 'cognito';
    }
    if (data.storeInCognito === false) {
      data.storage = 'native';
    }
    const resp = await updateUsersInTenant(getTenantName(meta), id, data);
    const user = processResponse(resp);
    const syncResp = await syncUpdateToVIA(getTenantName(meta), user?.name || id);
    const result = user || { name: id };
    if (syncResp && syncResp.status === 'OK') {
      result.synced = true;
    }
    return result;
  },
  deleteOne: async ({ id, meta }) => {
    const resp = await deleteUsersInTenant(getTenantName(meta), id);
    const syncResp = await syncDeletionToVIA(getTenantName(meta), id);
    const result = processResponse(resp) || { name: id };
    if (syncResp && syncResp.status === 'OK') {
      result.synced = true;
    }
    return result;
  },
  getApiUrl: () => {
    throw new Error("Function not implemented.");
  },
};
